<template>
  <div>
    <WebHeaderView :title="activity?.activity?.title" />
    <div class="page-content">
      <div style="width:90vw;margin: 20px auto;text-align: left;">
        当前剩余次数：<span style="font-weight: 600;">{{ activity?.user?.wheel_times }}</span>
      </div>
      <div style="width: 90vw; margin: 20px auto">
        <LuckyWheel
          ref="myLucky"
          width="90vw"
          height="90vw"
          :prizes="prizes"
          :blocks="blocks"
          :buttons="buttons"
          @start="startCallback"
          @end="endCallback"
        />
      </div>
      <div class="info-area">
        <div class="info-area-info" v-html="this.activity?.activity?.rule" />
      </div>
      <div class="info-area" v-if="record && record.length > 0">
        <VueSlickCarousel
          v-bind="slideOptions"
          v-if="record && record.length > 0"
        >
          <van-row
            v-for="(item, index) in record"
            :key="index"
            class="home-swip-item"
          >
            <van-col span="14" class="text-left">
              {{ item.user.phone }} 获得奖金 <span>{{ item.prize.title }}</span>
            </van-col>
            <van-col span="10" class="text-right">
              {{ item.created_at }}
            </van-col>
          </van-row>
        </VueSlickCarousel>
      </div>
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import WebHeaderView from '@/components/Header/index.vue'
export default {
  name: 'TurntableView',
  components: { WebHeaderView, VueSlickCarousel },
  data () {
    return {
      blocks: [],
      prizes: [],
      buttons: [],
      activity: {},
      record: [],
      tmpItem: null,
      slideOptions: {
        arrows: false,
        dots: false,
        infinite: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        vertical: true,
        verticalSwiping: true,
        autoplay: true,
        speed: 2000,
        autoplaySpeed: 2000
      },
      playing: false
    }
  },
  methods: {
    startCallback () {
      if (this.playing) return
      if (this.activity.user.wheel_times > 0) {
        this.playing = true
        this.$refs.myLucky.play()
        this.$http({
          method: 'post',
          url: 'WheelSpin'
        })
          .then(res => {
            setTimeout(() => {
              this.activity.user.wheel_times -= 1
              this.playing = false
              this.tmpItem = res.data
              const index = this.activity.prizes.findIndex(
                item => item.id == res.data.prize.id
              )
              this.$refs.myLucky.stop(index)
            }, 3000)
          })
          .catch(() => {
            this.playing = false
          })
      } else {
        this.$toast.fail('当前抽奖次数为 0！')
      }
    },
    // 抽奖结束会触发end回调
    endCallback () {
      if (this.tmpItem && this.tmpItem.result_type == 1) {
        this.$toast(`恭喜你获得:${this.tmpItem.prize.title}`)
      } else {
        this.$toast(this.tmpItem.prize.title)
      }
     this.tmpItem = null
    },
    async getConfig () {
      await this.$http({
        method: 'get',
        url: 'WheelConfig'
      }).then(res => {
        this.activity = res.data
        this.blocks = []
        let blockItem = {
          padding: this.activity.activity.bg_padding + 'px',
          background: this.activity.activity.pie_border_color,
          imgs: []
        }
        if (this.activity.activity.wheel_bg_image) {
          let imgobj = [
            {
              src: this.activity.activity.wheel_bg_image,
              top: this.activity.activity.bg_top,
              width: this.activity.activity.bg_width,
              height: this.activity.activity.bg_height,
              rotate: this.activity.activity.rotate == 1
            }
          ]
          blockItem.imgs = imgobj
        }
        this.blocks.push(blockItem)

        this.prizes = []
        this.activity.prizes.forEach(element => {
          let obj = {
            fonts: [
              {
                text: element.title,
                top: '20%',
                fontColor: this.activity.activity.text_color
              }
            ],
            background: element.item_bg_color,
            imgs: [
              {
                src: element.image,
                top: '5%',
                width: '20px',
                height: '20px'
              }
            ]
          }
          this.prizes.push(obj)
        })

        this.buttons = []
        this.buttons = []
        let btn = {
          radius: '20%',
          background: this.activity.activity.button_color,
          pointer: this.activity.activity.pointer == 1,
          imgs: [],
          fonts: []
        }
        if (
          this.activity.activity.button_image &&
          this.activity.activity.button_image.length > 0
        ) {
          const btn_img = {
            src: this.activity.activity.button_image,
            top: this.activity.activity.button_top + 'px',
            width: this.activity.activity.button_width + 'px',
            height: this.activity.activity.button_height + 'px'
          }
          btn.imgs.push(btn_img)
        }
        if (
          this.activity.activity.button_fronts &&
          this.activity.activity.button_fronts.length > 0
        ) {
          const font = {
            text: this.activity.activity.button_fronts,
            top: this.activity.activity.button_fronts_top + 'px',
            fontColor: this.activity.activity.button_fronts_color,
            fontSize: this.activity.activity.button_fronts_size,
            fontWeight: this.activity.activity.button_fronts_weight
          }
          btn.fonts.push(font)
        }
        this.buttons.push(btn)
      })
    },
    async getRecord () {
      await this.$http({
        method: 'get',
        url: 'WheelRecord'
      }).then(res => {
        this.record = res.data.data
        this.slideOptions.autoplay = true
      })
    }
  },
  mounted () {
    this.getConfig()
    // this.getRecord()
  }
}
</script>
<style scoped>
.info-area {
  width: 90vw;
  margin: 30px auto;
  border-radius: 10px;
  box-shadow: inset 0 0 10px rgba(255, 255, 255, 0.75);
  background: rgb(0, 0, 0, 0.75);
  padding: 10px;
}
.info-area-info {
  text-align: left;
  width: 100%;
  padding: 0px;
}
.home-swip-item {
  margin: 12px auto;
  height: 28px;
  line-height: 28px;
  font-size: 14px;
  padding: 0px 10px;
  width: calc(100% - 40px) !important;
}
.text-left {
  text-align: left;
}
.text-left span {
  color: #dfcb71;
  font-weight: 600;
  font-size: 16px;
}
.text-right {
  text-align: right;
}
</style>
